export const SUPPRESSED_PROPERTY_TYPE = "suppressedPropertyType"
